<template>
  <v-card class="elevation-1">
    <!-- header -->
    <div class="px-4 pt-3 pb-2" style="background: linear-gradient(to right, #0c2646, #2a5788)">
      <div class="d-flex align-center justify-space-between mb-1">
        <div class="d-flex align-center" style="gap: 8px; flex-wrap: wrap">
          <span class="headline font-weight-bold white--text">{{ meta.tipo_conteudo || "Peça" }}</span>
          <v-chip
            v-if="meta.superou_gmr"
            x-small
            color="amber darken-1"
            class="font-weight-bold black--text"
          >
            <v-icon left x-small color="black">mdi-chevron-double-up</v-icon>
            {{ labelGmr }}
          </v-chip>
        </div>
        <span class="caption font-weight-bold" style="color: rgba(255,255,255,0.9)">#{{ meta.id_campanha_meta }}</span>
      </div>
      <div class="d-flex align-center flex-wrap" style="gap: 2px 12px">
        <span class="caption" style="color: rgba(255,255,255,0.9)">
          <span style="color: rgba(255,255,255,0.6)">Realizado: </span>
          <span class="font-weight-medium">{{ meta.tipo_realizado || "—" }}</span>
        </span>
        <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
        <span class="caption" style="color: rgba(255,255,255,0.9)">
          <span style="color: rgba(255,255,255,0.6)">Cálculo: </span>
          <span class="font-weight-medium">{{ meta.tipo_calculo || labelCalculo }}</span>
        </span>
        <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
        <span class="caption" style="color: rgba(255,255,255,0.9)">
          <span style="color: rgba(255,255,255,0.6)">Pagamento: </span>
          <span class="font-weight-medium">{{ meta.tipo_pagamento || labelPagamento }}</span>
        </span>
        <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
        <span class="caption" style="color: rgba(255,255,255,0.9)">
          <span style="color: rgba(255,255,255,0.6)">Participantes: </span>
          <span class="font-weight-medium">{{ meta.nParticipantes }}</span>
        </span>
      </div>
    </div>

    <!-- filtros -->
    <v-card-text class="pb-0">
      <v-row dense align="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-autocomplete v-model="filters.empresa"    :items="opcoesEmpresa" label="Empresa"     clearable single-line dense />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-autocomplete v-model="filters.funcao"     :items="opcoesFuncao"  label="Função"      clearable single-line dense />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-autocomplete v-model="filters.peca"       :items="opcoesPeca"    label="Peça"        clearable single-line dense />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-autocomplete v-model="filters.ganhouItem" :items="simNao" item-text="text" item-value="value" label="Ganhou Item" clearable single-line dense />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-autocomplete v-model="filters.ganhouMeta" :items="simNao" item-text="text" item-value="value" label="Ganhou Meta" clearable single-line dense />
        </v-col>
      </v-row>
    </v-card-text>

    <ApuracaoTabelaPeca :rows="rowsFiltrados" :search="search" :gmr-info="gmrInfo" />

    <!-- footer -->
    <div class="d-flex justify-end align-center px-4 py-2" style="border-top: 1px solid rgba(0,0,0,0.12); background: rgba(0,0,0,0.02)">
      <span v-if="meta.superou_gmr && gmrInfo" class="caption amber--text text--darken-2 font-weight-medium mr-4">
        <v-icon x-small color="amber darken-2">mdi-chevron-double-up</v-icon>
        {{ labelGmr === '× 2' ? 'Bônus dobrado pelo GMR' : 'Bônus liberado' }}
      </span>
      <span class="caption grey--text text--darken-1">
        Total Bônus Pago:
        <strong class="ml-1">{{ totalBonusPago | BrazilianCurrency }}</strong>
      </span>
    </div>
  </v-card>
</template>

<script>
import apuracaoTipoMixin from "@/mixins/apuracaoTipoMixin";
import ApuracaoTabelaPeca from "../tabelas/ApuracaoTabelaPeca";

export default {
  name: "ApuracaoPeca",

  components: { ApuracaoTabelaPeca },

  mixins: [apuracaoTipoMixin],

  data() {
    return {
      simNao: [{ value: "S", text: "Sim" }, { value: "N", text: "Não" }],
      filters: {
        empresa:    null,
        funcao:     null,
        peca:       null,
        ganhouItem: null,
        ganhouMeta: null
      }
    };
  },

  computed: {
    opcoesPeca() {
      return [...new Set(this.meta.rows.map(r => r.peca_acessorio).filter(Boolean))].sort();
    },

    rowsFiltrados() {
      return this.rowsBase.filter(r => {
        if (this.filters.peca && r.peca_acessorio !== this.filters.peca) return false;
        if (this.filters.ganhouItem) {
          const val = r.ganhou_item === true || r.ganhou_item == 1 ? "S"
                    : r.ganhou_item === false || r.ganhou_item == 0 ? "N"
                    : r.ganhou_item;
          if (val !== this.filters.ganhouItem) return false;
        }
        return true;
      });
    },

    labelCalculo() {
      return this.meta.id_tipo_calculo == 2 ? "Faixa Progressiva" : "Meta Fixa";
    },

    labelPagamento() {
      return this.meta.id_tipo_pagamento == 1 ? "Por Unidade" : "Valor Fixo";
    }
  }
};
</script>
